
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n868Child = []
  var n869Child = []
  var n870Child = []
  var n871Child = []
  var n872Child = []
  var n873Child = []
  var n874Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-arrow-left'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n874 = h('i', props, n874Child)
  n873Child.push(n874)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n873 = h('span', props, n873Child)
  n872Child.push(n873)
  var n875Child = []
  n875Child = n875Child.concat(text(actionBaseT('.back')))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n875 = h('span', props, n875Child)
  n872Child.push(n875)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'button'},{name:'class', val: 'is-light'},{name:'class', val: 'is-small'},{name:'type', val: "button"},{name:'onclick', val: this.closeFull},{name:'title', val: actionBaseT('.back')}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n872 = h('button', props, n872Child)
  n871Child.push(n872)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-item'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n871 = h('div', props, n871Child)
  n870Child.push(n871)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-brand'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n870 = h('div', props, n870Child)
  n869Child.push(n870)
  var n876Child = []
  var n877Child = []
  var n878Child = []
  var v879 = this.fullBreadcrumbItems
  Object.keys(v879).forEach(function (index) {
    var item = v879[index]
    if(index > 0) {
      var n880Child = []
      var n881Child = []
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'fas'},{name:'class', val: 'fa-chevron-right'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n881 = h('i', props, n881Child)
      n880Child.push(n881)
      var props = {attributes: runtime.compileAttrs([{name:'class', val: 'icon'},{name:'class', val: 'is-small'},{name:'class', val: 'action-full-breadcrumb-separator'}], [])};
      if (props.attributes.id) props.key = props.attributes.id;
      var n880 = h('span', props, n880Child)
      n878Child.push(n880)
    }
    var n882Child = []
    n882Child = n882Child.concat(text(item))
    var props = {attributes: runtime.compileAttrs([{name:'class', val: 'action-full-breadcrumb-item'}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n882 = h('span', props, n882Child)
    n878Child.push(n882)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-item'},{name:'class', val: 'action-full-breadcrumbs'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n878 = h('div', props, n878Child)
  n877Child.push(n878)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-start'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n877 = h('div', props, n877Child)
  n876Child.push(n877)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'navbar-menu'},{name:'class', val: 'is-active'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n876 = h('div', props, n876Child)
  n869Child.push(n876)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'action-full-toolbar'},{name:'class', val: 'navbar'},{name:'class', val: 'is-dark'},{name:'class', val: 'is-flex-shrink-0'},{name:'role', val: "navigation"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n869 = h('nav', props, n869Child)
  n868Child.push(n869)
  var n883Child = []
  n883Child = n883Child.concat(text(form))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'action-full-body'},{name:'class', val: 'is-flex-grow-1'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n883 = h('div', props, n883Child)
  n868Child.push(n883)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'action-full'},{name:'class', val: 'is-flex'},{name:'class', val: 'is-flex-direction-column'},{name:'class', val: 'is-flex-grow-1'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n868 = h('div', props, n868Child)
  n0Child.push(n868)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  